import { ApprovalEnum } from "../enum"

export const convertApproval = (data: number) => {
  if (data === ApprovalEnum.PENDING) return "PENDING"
  if (data === ApprovalEnum.REVISED) return "REVISED"
  if (data === ApprovalEnum.REJECTED) return "REJECTED"
  if (data === ApprovalEnum.APPROVED) return "APPROVED"

  return "-"
}